<template>
  <div class="dashboard-quote-bar">
    <ul class="fixed-bar--bar">
      <li>
        <back-to-dashboard-link />
      </li>
      <li>
        <a @click="goToQuote">
          {{ i18n.t('/quotepage/customerconfigurationbutton') }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import BackToDashboardLink from '@/components/generic/presentational/molecules/backToDashboardLink/BackToDashboardLink.vue'

export default {
  components: {
    BackToDashboardLink,
  },
  props: {
    quoteId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    goToQuote() {
      let params = {
        cstType: this.$route.params.cstType,
        establishmentId: this.$route.params.establishmentId,
        quoteId: this.quoteId,
      }
      this.$router.replace({ name: 'configuration-page', params })
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-quote-bar {
  ul {
    list-style-type: none;

    li {
      :deep(.back-to-dashboard) {
        padding-top: 0;

        a {
          display: flex;
        }
      }

      :deep(a) {
        display: block;
        padding: 0.5rem 1rem;
        background-color: $color-primary;
        color: $white;

        &:hover {
          background-color: $color-primary-dark;
        }
      }
    }
  }
}
</style>
